import WebRouter from './WebRouter';

export default WebRouter;
